import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// The server puts a plain-text copy of some pages in the HTML for search engines
// and AI bots. Once the app runs, remove it so screen readers don't read it twice.
document.querySelectorAll('[data-prerender]').forEach(el => el.remove());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
